/**
 * The registration document of a competition's STAFF — a judge (optionally also
 * an organiser) or an organiser — at `competitions/{compId}/registrations/{uid}`.
 *
 * A competitor's entry is written by the `registerForCompetition` callable
 * (capacity, age and window are decided there); staff are appointed by the
 * organiser's own client write (`useCompetitionRegistry`), so this shape lives on
 * the client. It is one function so the E2E seed (tests/e2e/seed/competitions.js)
 * appoints a judge with the editor's exact document instead of a second copy.
 *
 * Pure: the caller owns `registeredAt` (an SDK sentinel — the client's and the
 * Admin SDK's differ) and the actor stamp (`lastModifiedBy`, which the rules pin to
 * the writer).
 *
 * A judge+organiser is ONE `role: "judge"` document with `isOrganizer: true` —
 * `isCompOrganizer` in firestore.rules reads either form.
 */

/** A judge's registration: assigned per session (`sessionIds`), never per route. */
export function buildJudgeRegistration({ uid, displayName, isOrganizer = false, sessionIds = [] }) {
  return {
    uid,
    displayName: displayName || "",
    role: "judge",
    isOrganizer: !!isOrganizer,
    groupId: null,
    sessionId: null,
    startNumber: null,
    sessionIds: Array.isArray(sessionIds) ? sessionIds : [],
    // sessionNames was denormalized here for cross-comp judge "my section"
    // badges without loading the comp's sessions subcollection. Removed — the
    // Competition tab resolves names from the loaded sessions array and falls
    // back to sessionId for older registrations.
  };
}

/** An organiser's registration (no judging duty). */
export function buildOrganizerRegistration({ uid, displayName }) {
  return {
    uid,
    displayName: displayName || "",
    role: "organizer",
    isOrganizer: true,
    groupId: null,
    sessionId: null,
    startNumber: null,
    sessionIds: [],
  };
}
